// extracted by mini-css-extract-plugin
export default {"spacer":"T1hKM1dm7lErEgPnGt80","subtle":"JnJ5aVWlN_t0wDrttCSz"};